import axios from 'axios'

const headers = { headers: { 'x-api-version': '1.0' } }
export const getBbl = () => {
  return axios.get(axios.defaults.baseURL + 'bbl/bbl', headers)
}

export const getBblSettings = () => {
  return axios.get(axios.defaults.baseURL + 'bbl/bbl/settings', headers)
}

export const getBblApplications = () => {
  return axios.get(axios.defaults.baseURL + 'bbl/bbl/applications', headers)
}

export const sendRequestToBbl = () => {
  return axios.post(
    window.config.api.url + 'bblid/access/request', null,
    {
      headers: { 'x-api-version': '1.0-public' },
    }
  )
}
